import { SEND_ANALYTICS, SendAnalyticsAPI } from '@weblite-wapps/protocol'
import { wappSystemApi } from 'weblite-web-wapprunner/src/setup/root'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'

wappSubscription.subscribe<SendAnalyticsAPI>(
  SEND_ANALYTICS,
  (payload, meta) => {
    const wappVersion = wappSystemApi?.getWappVersion?.(meta.wappId)
    const { wappId, wisId } = meta || {}

    analite(payload.type, {
      ...payload.data,
      wappVersion,
      wappId,
      wisId,
    })

    return { status: 'ok' }
  },
)
